import React, { useState } from 'react'
import { Card } from 'react-bootstrap';
import { CgProfile } from 'react-icons/cg';
import SignIn from '../Components/SignIn';
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

const Profile = () => {
    
    const [ signInPopUp, setSignInPopUp ] = useState(false)
    const userData = JSON.parse(localStorage.getItem("user"))

    const handleOpen = () => setSignInPopUp(true);
    const handleClose = () => setSignInPopUp(false);

    const getInitials = (name) => {
        if (!name) return ''
        const words = name.trim().split(' ')
        const initials = words.length >= 2 
          ? words[0][0] + words[1][0] 
          : words[0][0]
        return initials.toUpperCase()
    }

    const handleSignOut = () => {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("user");
            window.location.reload(); // Change page reload later when better UX is required
          })
          .catch((error) => {
            console.error("Error signing out:", error);
          });
    };

    return (
        <div>
            <Card className='card-background'>
                <div className='profile'>
                    <div className='profile-initials-icon'>{userData ? getInitials(userData?.displayName) : <CgProfile />}</div>
                    {
                        userData ? (
                            <>
                                <div className='profile-options'>{userData?.displayName?.toLowerCase()}</div>
                                <div className='profile-options'>orders</div>
                                <div className='profile-options' onClick={() => handleSignOut()}>sign out</div>
                            </>
                        ) : (
                            <>
                                <div className='profile-options' onClick={() => handleOpen()}>sign in</div>
                            </>
                        )
                    }
                </div>
                {signInPopUp &&
                    <SignIn openModal={signInPopUp} onHandleClose={() => handleClose()} />
                }
            </Card>
        </div>
    )
}

export default Profile